import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import { SEO_PAGES } from "@/data/seoPages";

const Home = lazy(() => import("@/pages/Home"));
const SeoPage = lazy(() => import("@/pages/SeoPage"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const Terms = lazy(() => import("@/pages/Terms"));
const RefundPolicy = lazy(() => import("@/pages/RefundPolicy"));
const Contact = lazy(() => import("@/pages/Contact"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const Loader = () => (
  <div className="flex min-h-[70vh] items-center justify-center" data-testid="page-loader">
    <div className="flex h-10 items-end gap-1.5" aria-hidden="true">
      {[0, 1, 2, 3, 4].map((i) => (
        <span
          key={i}
          className="w-1.5 h-full origin-bottom rounded-full bg-gradient-to-t from-neon-pink via-neon-purple to-neon-blue animate-eq-bar"
          style={{ animationDelay: `${i * 0.12}s` }}
        />
      ))}
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <div className="noise-overlay" aria-hidden="true" />
        <Header />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            {Object.keys(SEO_PAGES).map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<SeoPage slug={slug} />} />
            ))}
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
        <FloatingWhatsApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
